import { Heading, Subheading } from "../design/heading";
import { IntakeRating } from "../models/Intake";

interface IntakeRatingViewProps {
  rating: IntakeRating;
}

const IntakeRatingView: React.FC<IntakeRatingViewProps> = ({ rating }) => {
  return (
    <div>
      {rating.overallRating && <Heading>{rating.overallRating}</Heading>}
      {rating.evidenceStrength && (
        <Subheading>Event Strength: {rating.evidenceStrength}</Subheading>
      )}
      {rating.legalViability && (
        <Subheading>Legal Viability: {rating.legalViability}</Subheading>
      )}
      {rating.financialConsiderations && (
        <Subheading>
          Financial Considerations: {rating.financialConsiderations}
        </Subheading>
      )}
      {rating.proceedWithMatter && (
        <Subheading>
          Proceed With Matter: {rating.proceedWithMatter ? "Yes" : "No"}
        </Subheading>
      )}
    </div>
  );
};

export default IntakeRatingView;
